export const OurTeam = [
    "We have been the best cross-platform Flutter app development company. Having said that, we have the most knowledgeable & experienced developers be it Android, iOS development or any other app development. At IStellar, we believe in quality work and so are setting trends as Flutter 2 app development company.",
    "Even though Flutter being new in IStellar we have highly experienced & dedicated team of Flutter developers. Helping Businesses, around the globe, creating next generation mobile apps that are adaptable & expressive. Further giving a wonderful products to the clients as well – that too not compromising with price & time. Hire Flutter developer in IStellar today!"
]
export const OtherMobileServices = [
    {ul: [
        {li: "React Native development",
        path: "/services/react-native-development"},
        {li: "Ionic development",
        path: "/services/ionic-development"},
        {li: "PhoneGap development",
        path: "/services/phonegap-development"},
    ]}
]
export const WhyRightChoice = [
    "MitrahSoft provides knowledgeable, professional & experienced flutter developers. Our Developers develop delightful and versatile applications that fulfil your specific needs. Our Flutter devs can develop flutter apps and deliver a customized solution as per client’s requirements at competitive price. Hire Flutter App developer from MitrahSoft & let’s connect and make it happen together!.",
    "To miss the features of native Android apps is no more the issue, as Google recently enhances its support for developing the cross-platform app utmost close to the native user experience. The highlights, simplicity, and power of customization that Flutter app development unleashes, have discovered it a continually widening adaption and fan following.",
    "From consulting to design, development, testing, launch, and maintenance we do it all. Our team of best Flutter developers is armed with the latest flutter dev tools and technologies."
]
export const WhyRightChoiceList = [
"100% straightforwardness all throughout the development process",
"Experienced team of developers to guide what's best in trends for your business",
"Get high performance, native-like mobile apps with Flutter on time and within your budget",
"Rewrite existing app using Flutter for iPhone and Android",
"Get MVP(Minimum Viable Product) live ASAP",
"Add feature to React Native mobile application",
"Make the app compliant to the regulations",
"Custom mobile application development",
]
export const flutterPara = [
    "Start working with IStellar that can provide everything for your mobile apps."
]
export const flutterImg1 = [
    "flutterImg1"
]
export const flutterImg2 = [
    "flutterImg2"
]
export const cardServices = [
    {
        id: 1,
        title: "Expert Flutter Development Team",
        content: "Our developers deliver powerful, dynamic and robust mobile apps that work flawlessly across multiple platforms. They create high performance, Native-Like Mobile Apps with Flutter on Time."
    }, {
        id: 2,
        title: "Dart based Development",
        content: "Flutter makes use of DART and it's a programming language which is developed by Google. DART promises intuitive apps for the mobile as well as web with cleaner UI and faster performance."
    }, {
        id: 3,
        title: "Full Native Functionality",
        content: "Flutter don't need a JavaScript bridge to access OEM widgets and its promising better native functionality than apps developed in other language."
    }, {
        id: 4,
        title: "Perfect for MVP",
        content: "A minimum viable product (MVP) is required by startup to quickly roll out a functioning version of their app to showcase to investors or for real-life testing. Flutter makes it easier and it is suitable for MVP development."
    }, {
        id: 5,
        title: "App specialization and design",
        content: "It doesn't matter what business you own, you can get the best solutions over app specialization and design in Flutter."
    }, {
        id: 6,
        title: "Complete Platform Utilization",
        content: "While developing app in Flutter we do not focus on a single thing. Using the Flutter platform’s customization abilities with UI refining, we promise exciting experiences that users love."
    }, {
        id: 7,
        title: "Project consultation",
        content: "MitrahSoft Flutter experts have strong knowledge, you can contact Flutter team and check for consultation & estimation for your project. You can share all your expectation with them and they will guide you further."
    }, {
        id: 8,
        title: "Rich user Interface",
        content: "Even in older versions of Android & iOS, we can use Flutter and create dynamic and awesome user interface. This means consistent user experience without a glitch or any reason for users to get disappointed about."
    }, {
        id: 9,
        title: "Cost Effective",
        content: "Flutter supports code-reusability well and it becomes cheaper for businesses to build and deliver cross-platform mobile apps. With the same cost, businesses can reach out to customers in multiple platforms."
    }
]